<template>
  <div class="vd__login-container">
    <div class="vd__login_form_container">
      <div class="vd__login_logo"><icon-videsk/></div>
      <div class="vd__login_title">{{ $t('login.title') }}</div>
      <a-form
        :form="form"
        @submit="handleSubmit">
        <!-- Email -->
        <a-form-item
          class="vd__input_login"
          :wrapper-col="{ span: 48 }">
          <a-input
            size="large"
            type="text"
            :placeholder="$t('login.email')"
            v-decorator="[
              'email',
              {rules: [ { required: true,
              message: this.$t('login.errors.email') }]}
            ]"><a-icon slot="suffix" type="user" /></a-input>
        </a-form-item>
        <!-- Password -->
        <a-form-item
          class="vd__input_login"
          :wrapper-col="{ span: 48 }">
          <a-input
            size="large"
            type="password"
            :placeholder="$t('login.password')"
            v-decorator="['password',
            {rules: [ { required: true,
            message: this.$t('login.errors.password') }]}]">
            <a-icon slot="suffix" type="lock" />
          </a-input>
        </a-form-item>
        <!-- Login button -->
        <a-form-item
          :wrapper-col="{ span: 48 }"
        >
          <a-button
            size="large"
            type="primary"
            html-type="submit"
            :loading="loading"
            block>
            {{ $t('login.login') }}
          </a-button>
        </a-form-item>
      </a-form>
      <!-- End login form -->
      <!-- Forget password option -->
      <div class="vd__forgot-password-container">
        <div>{{ $t('login.forgot') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from '@/components/icon-component.vue';

export default {
  components: {
    'icon-videsk': icon,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      formLayout: 'vertical',
      auth: null,
      loading: false,
    };
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault();
      this.loading = true;

      let values;
      this.form.validateFields((error, data) => { if (!error) values = data; });
      if (!values) return this.errorOnLogin();

      const { email, password } = values;

      const response = await this.axios.post('/auth/login', {
        strategy: 'local', email, password, agreement: true,
      }).catch(e => e);
      if (response instanceof Error) return this.errorOnLogin(response);

      const {
        level, accessToken, refreshToken, user,
      } = response.data;
      if (level > 1) return alert('No tienes autorización.');

      // eslint-disable-next-line no-underscore-dangle
      this.setData(user._id, user.account);

      await this.$authorization.set(accessToken, refreshToken, true);
      this.setAuthorizationHeader();

      this.$router.push({ name: 'accounts' });

      this.$notification.success({ message: `${this.$t('login.correct')} 😁` });

      this.loading = false;
    },
    setAuthorizationHeader() {
      const { storage, keys } = this.$authorization;
      const accessToken = this.$authorization.constructor.getTokens(storage, keys, 'accessToken');
      this.axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    },
    setData(userId, account) {
      this.$store.commit('global/account', account);
      this.$store.commit('global/id', userId);
      this.$store.dispatch('global/getUserData');
    },
    errorOnLogin(error) {
      this.loading = false;
      if (!error) return this.$notification.error({ message: 'Uuups! 😱', description: this.$t('login.errors.incorrect') });
      const { status } = error.response || {};
      if (!status) this.$notification.error({ message: 'Al parecer no estás conectado a Internet.' });
      else if (status === 401) this.$notification.error({ message: !this.showOtp ? `${this.$t('login.errors.incorrect')} 😨` : 'Clave 2FA expirada, prueba con una nueva.' });
      else if (status === 402) this.$notification.error({ message: `${this.$t('login.errors.subscriptions')}` });
      else if (status === 403) this.$notification.error({ message: 'No tienes autorización para conectar mediante la actual dirección IP.' });
      else if (status === 406) this.showOtp = true;
      else if (status === 503) this.$notification.error({ message: 'Haz superado el límite de intentos al iniciar sesión.' });
      else this.$notification.error({ message: `${this.$t('login.errors.global')}` });
    },
  },
};
</script>

<style>
.vd__login-container{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
}
  .vd__login_form_container{
    width: 35%;
    height: 100%;
    padding: 4%;
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .vd__login_promo_container{
    width: 65%;
    height: 100%;
    padding: 0;
    margin: 0;
    background: linear-gradient(225deg, #0ab3e4, #102976);
  }

  .vd__login_logo{
    width: 80px;
    height: 80px;
    margin-bottom: 15px;
  }

  .vd__login_title{
    font-size: 2.3em;
    font-weight: bold;
    margin-bottom: 25px;
    color: #585858;
  }

  .vd__input_login{
    margin-bottom: 10px;
  }

  .vd__forgot-password-container{
    color: var(--color);
    margin: 10px 0;
    cursor: pointer;
    text-align: right;
    opacity: 0.7;
    transition: all .3s ease;
  }

.vd__forgot-password-container:hover{
  opacity: 1;
  transition: all .3s ease;
}
</style>

<style>
  .vd__svg_icon_videsk{
    fill: #005bea;
  }
</style>
